var map = {
	"./fonts/SuisseIntl-Bold.ttf": 1293,
	"./fonts/SuisseIntl-Regular.ttf": 1294,
	"./fonts/SuisseNeue-Regular.ttf": 1295,
	"./images/WIENXTRA-template-briefpapier-Weltkugel.png": 1296,
	"./images/WIENXTRA-wortmarke-CMYK-2c.png": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1292;